<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      width="1024"
      @click:outside="dialog = false"
    >
      <template #activator="{ props }">
        <v-btn
          v-if="this.tipoB"
          variant="text"
          :color="this.color"
          v-bind="props"
          append-icon="mdi-pencil-outline"
          :class="this.text ? '' : 'button'"
        >
          {{ this.text }}
        </v-btn>
        <v-btn
          v-else
          density="comfortable"
          icon="mdi-pencil"
          v-bind="props"
        ></v-btn>
      </template>

      <v-card>
        <v-card-title>
          <div class="d-flex justify-space-between">
            <span class="text-h5">Editar Requisito</span>
            <v-btn
              variant="plain"
              rounded="xl"
              prepend-icon="mdi-window-close"
              @click="dialog = false"
            ></v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form ref="form" validate-on="lazy submit">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="identificacao"
                    label="Identificação*"
                    required
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-select
                    :disabled="isDisabled"
                    v-model="tipo_requisito"
                    :items="[
                      'Restrição organizacional',
                      'Restrição externa',
                      'Restrição qualidade',
                    ]"
                    label="Tipo Requisito*"
                    required
                    :rules="tipoRequisitoRules"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="descricao"
                    required
                    label="Descrição*"
                    rows="3"
                    :rules="descricaoRules"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="observacao"
                    required
                    label="Observação"
                    rows="3"
                    :rules="observacaoRules"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <small>*Campos obrigatórios</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="yellow-darken-4"
            variant="text"
            @click="saveDraft"
            v-if="rascunho"
          >
            Salvar Rascunho
            <v-tooltip activator="parent" location="top"
              >As alterações feitas não serão registradas no
              histórico.</v-tooltip
            >
            <v-progress-circular
              v-if="this.isLoadingDraft"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>

          <v-btn color="blue-darken-1" variant="text" @click="handleUpdate">
            Atualizar
            <v-tooltip activator="parent" location="top"
              >As alterações feitas serão registradas no histórico.</v-tooltip
            >
            <v-progress-circular
              v-if="this.isLoading"
              class="ml-2"
              indeterminate
              size="20"
            />
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>

  <v-dialog v-model="showDialog" max-width="512">
    <v-card>
      <v-card-title class="headline"> Confirmação </v-card-title>

      <v-card-text>
        O requisito já está definido? Caso haja a confirmação, o controle de
        histórico do requisito será iniciado.
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn color="red darken-1" dark @click="showDialog = false">Não</v-btn>
        <v-btn
          color="blue darken-1"
          dark
          @click="
            () => {
              updateForm();
              showDialog = false;
            }
          "
          >Sim</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * @module ModalEditarRequisitos
 * @desc Modal para realizar a edição de um determinado requisito
 * @vue-data {string} [projetoID=null] - ID do projeto.
 * @vue-data {string} [csuID=null] - ID do caso de uso.
 * @vue-data {string} [id_requisito=null] - ID do requisito.
 * @vue-data {string} [identificacao=''] - A identificação do requisito.
 * @vue-data {string} [descricao=''] - A descrição do requisito.
 * @vue-data {boolean} [dialog=false] - Define se a caixa de diálogo
 * está aberta ou fechada.
 * @vue-data {string} [observacao=''] - A observação do requisito.
 * @vue-data {string} [tipo_requisito=''] - O tipo do requisito.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se o requisito
 * ainda está sendo editado.
 * @vue-data {Boolean} [isLoadingDraft=false] - Flag que indica se o rascunho
 * do requisito ainda está sendo salvo.
 * @vue-data {Boolean} [showDialog=false] - Flag que indica se o modal para
 * confirmação está visível
 */
import axios from 'axios';

import store from '@/store/store';
export default {
  emits: ['requisitoEditado', 'rascunhoSalvo'],
  data: () => ({
    csuID: null,
    projetoID: null,
    // eslint-disable-next-line camelcase
    id_requisito: null,
    identificacao: '',
    descricao: '',
    dialog: false,
    observacao: '',
    // eslint-disable-next-line camelcase
    tipo_requisito: '',
    rascunho: false,
    isLoading: false,
    isLoadingDraft: false,
    showDialog: false,
    tipoRequisitoRules: [(v) => !!v || 'Tipo de requisito é obrigatório'],
    descricaoRules: [(v) => !!v.trim() || 'Descrição é obrigatória'],
    observacaoRules: [
      (v) => v.length <= 100 || 'Observação deve ter no máximo 500 caracteres',
    ],
  }),
  computed: {
    isDisabled() {
      console.log(this.identificacao.split(' ')[0]);

      return this.identificacao.split(' ')[0] === 'RF';
    },
  },
  mounted() {
    this.projetoID = this.$route.params.idProjeto;
    this.csuID = this.$route.params.id;
    // eslint-disable-next-line camelcase
    this.id_requisito = this.requisito.id_requisito;
    this.descricao = this.requisito.descricao;
    this.identificacao = this.requisito.identificacao;
    this.observacao = this.requisito.observacao;
    // eslint-disable-next-line camelcase
    this.tipo_requisito = this.converterEnumParaTexto(
      this.requisito.tipo_requisito,
    );
    this.rascunho = this.requisito.rascunho;

    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com a funcionalidade de atualizar o caso de uso.
     */
    handleUpdate() {
      if (this.rascunho) {
        this.showDialog = true;
      } else {
        this.updateForm();
      }
    },

    /**
     * Formata as strings do enum;
     */
    converterTextoParaEnum(string) {
      /// TIPO REQUISITO.
      if (string === 'Restrição funcional') {
        return 'RESTRICAO_FUNCIONAL';
      } else if (string === 'Restrição organizacional') {
        return 'RESTRICAO_ORGANIZACIONAL';
      } else if (string === 'Restrição externa') {
        return 'RESTRICAO_EXTERNA';
      } else if (string === 'Restrição qualidade') {
        return 'RESTRICAO_QUALIDADE';
      }
    },
    converterEnumParaTexto(string) {
      /// TIPO REQUISITO.
      if (string === 'RESTRICAO_FUNCIONAL') {
        return 'Restrição funcional';
      } else if (string === 'RESTRICAO_ORGANIZACIONAL') {
        return 'Restrição organizacional';
      } else if (string === 'RESTRICAO_EXTERNA') {
        return 'Restrição externa';
      } else if (string === 'RESTRICAO_QUALIDADE') {
        return 'Restrição qualidade';
      }
    },
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Realiza uma requisição HTTP para salvar o rascunho do requisito.
     */
    async saveDraft() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          identificacao: this.identificacao,
          descricao: this.descricao,
          // eslint-disable-next-line camelcase
          tipo_requisito: this.converterTextoParaEnum(this.tipo_requisito),
          observacao: this.observacao.trim(),
        };

        try {
          this.isLoadingDraft = true;
          const apiUrl = process.env.VUE_APP_API_URL;
          const response = await axios.put(
            `${apiUrl}/api/v1/requisitos/${this.id_requisito}/rascunho`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          this.$toast.success(response.data.msg);
          this.$emit('rascunhoSalvo', this.id);
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoadingDraft = false;
          this.dialog = false;
        }
      }
    },

    /**
     * Atualiza o formulário por uma requisição HTTP.
     */
    async updateForm() {
      const isValid = (await this.$refs.form.validate()).valid;

      if (isValid) {
        const data = {
          identificacao: this.identificacao,
          descricao: this.descricao,
          // eslint-disable-next-line camelcase
          tipo_requisito: this.converterTextoParaEnum(this.tipo_requisito),
          observacao: this.observacao,
        };
        try {
          this.isLoading = true;
          const apiUrl = process.env.VUE_APP_API_URL;

          const response = await axios.put(
            `${apiUrl}/api/v1/requisitos/${this.id_requisito}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${store.state.token}`,
              },
            },
          );

          const newID = response.data.id;

          this.$toast.success(response.data.msg);
          this.$emit('requisitoEditado', newID);

          if (this.text) {
            this.$router.push(
              `/projects/${this.projetoID}/Requisitos/${newID}`,
            );
          }
        } catch (error) {
          console.log(error);
          this.$toast.error(error.response.data.msg);
        } finally {
          this.isLoading = false;
          this.dialog = false;
        }
      }
    },
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    requisito: Object,
    tipoB: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'Editar',
    },
    color: {
      type: String,
      default: 'orange',
    },
  },
};
</script>
<style scoped>
.button {
  min-width: 0;
  width: 0;
  padding: 0px;
}
</style>
